import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { subscriptionsService } from '../api/subscriptions.service';

export function useSubscriptionsByCompanyQuery(companyId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.subscriptions.byCompany(companyId ?? ''),
    queryFn: () => subscriptionsService.list({ companyId: companyId!, limit: 50 }),
    enabled: !!companyId,
  });
}
